import {
    SALES_BREAKDOWN_SUCCESS,
    SALES_BREAKDOWN_LOADING
} from '../actions/SalesBreakdown';

const initialState = {
    amazon: {
        salesBreakdownData: null,
        isLoading: true
    },
    shopify: {
        salesBreakdownData: null,
        isLoading: true
    },
    wholesale: {
        salesBreakdownData: null,
        isLoading: true
    },

};

const salesBreakdown = (state = initialState, action = {}) => {
    switch (action.type) {
        case SALES_BREAKDOWN_SUCCESS:
            return { ...state, [action.vendor]: { salesBreakdownData: action.data, isLoading: false } };
        case SALES_BREAKDOWN_LOADING:
            return { ...state, [action.vendor]: { ...state?.[action.vendor], isLoading: action.isLoading } };

        default:
            return state;
    }
};

export default salesBreakdown;
